import React from "react";
import { CheckCircle2 } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StickyCall from "../components/StickyCall";
import { CallButtons, Breadcrumbs, FaqList, LinkChips } from "../components/PageBlocks";
import { villesSEO } from "../villes";
import { servicesSeo } from "../servicesSeo";

export default function ServicePage({ service: s }) {
  const autres = servicesSeo.filter((x) => x.slug !== s.slug);
  return (
    <div data-testid={`service-page-${s.slug}`}>
      <Header />
      <StickyCall />
      <section className="hero-radial py-14 md:py-20">
        <div className="container-narrow">
          <Breadcrumbs items={[{ label: s.h1 }]} />
          <div className="grid md:grid-cols-2 gap-8 md:gap-10 items-center">
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] text-gold-deep mb-3">{s.over}</p>
              <h1 data-testid="service-h1" className="font-display text-4xl md:text-5xl gold-gradient-text mb-4">{s.h1}</h1>
              <div className="gold-divider my-5 max-w-[220px]" />
              <p className="text-gold-soft/95 leading-relaxed mb-6">{s.intro}</p>
              <CallButtons id="service-hero" context={s.h1} />
            </div>
            <div className="relative rounded-xl overflow-hidden gold-border-strong">
              <img src={s.img} alt={s.alt} width="940" height="650" className="w-full h-[300px] md:h-[440px] object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-14 md:py-16 bg-charcoal">
        <div className="container-narrow max-w-4xl space-y-12">
          {s.sections.map((x) => (
            <article key={x.h2}>
              <h2 className="font-display text-2xl md:text-3xl gold-gradient-text mb-5">{x.h2}</h2>
              <div className="gold-divider mb-6 max-w-[180px]" />
              <p className="text-gold-soft/95 leading-relaxed">{x.p}</p>
            </article>
          ))}
          <div className="card-onyx rounded-xl p-8">
            <h2 className="font-display text-xl text-gold mb-4">Ce que Maître Diamma peut faire pour vous</h2>
            <ul className="grid sm:grid-cols-2 gap-3">
              {s.bullets.map((b) => (
                <li key={b} className="flex items-start gap-2 text-sm text-gold-soft/95"><CheckCircle2 className="w-4 h-4 text-gold mt-0.5 shrink-0" /> {b}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <FaqList title="Questions fréquentes" faqs={s.faqs} />
      <section className="py-12 hero-radial">
        <div className="container-narrow text-center max-w-2xl mx-auto">
          <h2 className="font-display text-2xl md:text-3xl gold-gradient-text mb-5">Premier contact gratuit et confidentiel</h2>
          <CallButtons id="service-cta" center context={s.h1} />
        </div>
      </section>
      <LinkChips testid="service-other-links" title="Autres spécialités" links={[...autres.map((x) => ({ to: `/${x.slug}`, label: x.h1 })), { to: "/retour-affectif", label: "Retour affectif" }, { to: "/voyance", label: "Voyance" }, { to: "/guerisseur", label: "Guérisseur africain" }]} />
      <LinkChips testid="service-city-links" title={`${s.nav} à Orléans, dans le Loiret et alentours`} links={villesSEO.map((v) => ({ to: `/marabout/${v.slug}`, label: `${s.nav} ${v.nom}` }))} />
      <Footer />
    </div>
  );
}
